// Quick Boosts - Immediate Help Content
// Icons are imported as components and rendered dynamically in WisdomPage
import { Feather, Sun, Heart, Sparkles, Clock, Smile } from "lucide-react";

export const quickBoosts = [
	{
		id: "boost-sabr",
		icon: Feather,
		iconColor: "text-mint-accent",
		title: "Power of Sabr",
		description: "Endure the urge for 5 minutes. It will pass like a wave.",
	},
	{
		id: "boost-morning",
		icon: Sun,
		iconColor: "text-amber-400",
		title: "Morning Adhkar",
		description: "Armor your day. Recite: 'Hasbunallahu wa ni'mal wakeel.'",
	},
	{
		id: "boost-mindfulness",
		icon: Heart,
		iconColor: "text-rose-400",
		title: "Mindfulness",
		description: "Allah is Al-Raqib. He is witnessing your effort right now.",
	},
	{
		id: "boost-gratitude",
		icon: Sparkles,
		iconColor: "text-purple-400",
		title: "Gratitude",
		description: "List 3 things you are grateful for to reset your dopamine.",
	},
	{
		id: "boost-reset",
		icon: Clock,
		iconColor: "text-blue-400",
		title: "5-Minute Reset",
		description: "The 5-4-3-2-1 rule. Stand up, move, and break the circuit.",
	},
	{
		id: "boost-self-talk",
		icon: Smile,
		iconColor: "text-orange-400",
		title: "Positive Self-Talk",
		description: "I am a Mumin. This habit is not my identity. I can start over.",
	},
];
